export const selectAssets = (state) => state.asset.assets;
export const selectAssetsLoading = (state) => state.asset.loading;
export const selectAssetsError = (state) => state.asset.error;
export const selectCurrentAsset = (state) => state.asset.currentAsset;
export const selectTotalAssets = (state) => state.asset.totalAssets;
export const selectAssetType = (state) => state.asset.assetType;
export const selectAssetBulkDeleting = (state) => state.asset.bulkDeleting;
export const selectAssetBulkCompletedAt = (state) => state.asset.bulkCompletedAt;
export const selectAssetBulkNotice = (state) => state.asset.bulkNotice;
export const selectAssetPageQuery = (state) => state.asset.pageQuery;
